import Axios from "axios";
import {
    SET_SALARY_BANK_ADVICE_REPORT_LIST, 
    UNSET_SALARY_BANK_ADVICE_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalaryBankAdviceReport,
} from "@/store/api";

const state = {
    getSalaryBankAdviceReport: [],
};

const getters = {
    getSalaryBankAdviceReport(state) {
        return state.getSalaryBankAdviceReport;
    },
};

const mutations = {
    [SET_SALARY_BANK_ADVICE_REPORT_LIST](state, data) {
        state.getSalaryBankAdviceReport = data;
    },
    [UNSET_SALARY_BANK_ADVICE_REPORT_LIST](state) {
        state.getSalaryBankAdviceReport = [];
    },
};

const actions = {

    getSalaryBankAdviceReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalaryBankAdviceReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_BANK_ADVICE_REPORT_LIST, response.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_BANK_ADVICE_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};